import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { getOfficeReportsFailure, getOfficeReportsSuccess} from "../../Actions";
import { api } from "../../Config/ApiInterface";
import { getAllMainReportsFailure, getAllMainReportsSuccess, getFinancialReportsFailure, getFinancialReportsSuccess, getRecentNotificationsFailure, getRecentNotificationsSuccess } from "../../Actions/Dashboard/DashboardAction";
import { getPaymentMethodsReportSuccess, getPaymentMethodsReportFailure } from "../../Actions/Dashboard/DashboardAction";

function* getFrontDeskReportSaga(action) {
    const { page, limit, startDate, endDate, filterType, sortBy, sortOrder, name, hotel_id } = action.payload;
    const params = new URLSearchParams({ page, limit });
    if (sortBy) params.set("sortBy", sortBy);
    if (sortOrder) params.set("sortOrder", sortOrder);
    if (name) params.set("name", name);
    if (startDate) params.set("startDate", startDate);
    if (endDate) params.set("endDate", endDate);
    if (filterType) params.set("filterType", filterType);
    if (hotel_id) params.set("hotel_id", hotel_id);
    try {
        const response = yield call(api.post, `/report/front-office-reports?${params}`);
        if (response) {
            yield put(getOfficeReportsSuccess(response.data));
        } else {
            yield put(getOfficeReportsFailure(response.error || "Failed to fetch report."));
        }
    } catch (error) {
        yield put(getOfficeReportsFailure(error.message));
        // toast.error("Failed to fetch offers.");
    }
}

function* getFinancialReportSaga(action) {
  let { page, limit, startDate, endDate, filterType, sortBy, sortOrder, name, hotel_id } = action.payload;
  // Ensure startDate and endDate have correct time boundaries
  if (startDate && !startDate.includes('T')) {
    startDate = startDate + 'T00:00:00';
  }
  if (endDate && !endDate.includes('T')) {
    endDate = endDate + 'T23:59:59';
  }
  const params = new URLSearchParams({ page, limit });
  if (sortBy) params.set("sortBy", sortBy);
  if (sortOrder) params.set("sortOrder", sortOrder);
  if (name) params.set("name", name);
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  if (filterType) params.set("filterType", filterType);
  if (hotel_id) params.set("hotel_id", hotel_id);

  try {
    const response = yield call(
      api.post,
      `/report/financial-reports?${params}`
    );
    if (response) {
      yield put(getFinancialReportsSuccess(response.data));
    } else {
      yield put(
        getFinancialReportsFailure(response.error || "Failed to fetch report.")
      );
    }
  } catch (error) {
    yield put(getFinancialReportsFailure(error.message));
    // toast.error("Failed to fetch offers.");
  }
}

function* getAllMainReportSaga(action) {
  let { page, limit, startDate, endDate, filterType, path, sortBy, sortOrder, name } = action.payload;
  // Ensure startDate and endDate have correct time boundaries
  if (startDate && !startDate.includes('T')) {
    startDate = startDate + 'T00:00:00';
  }
  if (endDate && !endDate.includes('T')) {
    endDate = endDate + 'T23:59:59';
  }
  const hotel_id=localStorage.getItem('hotel_id');
  const params = new URLSearchParams({ page, limit, path });
  if (sortBy) params.set("sortBy", sortBy);
  if (sortOrder) params.set("sortOrder", sortOrder);
  if (name) params.set("name", name);
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  if (filterType) params.set("filterType", filterType);
  if (hotel_id) params.set("hotel_id", hotel_id);

  try {
    const response = yield call(
      api.post,
      `/report/${path}?${params}`
    );
    if (response) {
      yield put(getAllMainReportsSuccess(response.data));
    } else {
      yield put(
        getAllMainReportsFailure(response.error || "Failed to fetch report.")
      );
    }
  } catch (error) {
    yield put(getAllMainReportsFailure(error.message));
    // toast.error("Failed to fetch offers.");
  }
}

function* getPaymentMethodsReportSaga(action) {
  try {
    // Always send filterType, startDate, endDate in the POST body
    const { filterType, startDate, endDate } = action.payload || {};
    const response = yield call(api.post, "/report/payment-types", { filterType, startDate, endDate });
    if (response && response.data) {
      yield put(getPaymentMethodsReportSuccess(response.data));
    } else {
      yield put(getPaymentMethodsReportFailure(response.error || "Failed to fetch payment methods report."));
    }
  } catch (error) {
    yield put(getPaymentMethodsReportFailure(error.message));
  }
}

function* getRecentNotificationsSaga(action) {
  try {
    const response = yield call(api.get, "/report/recent-notifications");
    if (response && response.data && response.data.data) {
      yield put(getRecentNotificationsSuccess(response.data.data));
    } else {
      yield put(getRecentNotificationsFailure(response?.data?.message || "Failed to fetch notifications."));
      toast.error(response?.data?.message || "Failed to fetch notifications.");
    }
  } catch (error) {
    yield put(getRecentNotificationsFailure(error.message));
    toast.error(error.message || "Failed to fetch notifications.");
  }
}

export {
  getFrontDeskReportSaga,
  getFinancialReportSaga,
  getAllMainReportSaga,
  getPaymentMethodsReportSaga,
  getRecentNotificationsSaga,
};